import { render, staticRenderFns } from "./shopsList.vue?vue&type=template&id=0f7faba4&scoped=true"
import script from "./shopsList.vue?vue&type=script&lang=js"
export * from "./shopsList.vue?vue&type=script&lang=js"
import style0 from "./shopsList.vue?vue&type=style&index=0&id=0f7faba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7faba4",
  null
  
)

export default component.exports